import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  Input,
  Select,
  Loader,
  EmptyState,
  PageTitle,
  Text,
  FlexiPagination,
} from "@flexisaf/flexibull2";
import { useNavigate } from "react-router-dom";
import useExamGroupsGet from "../../hooks/exam-groups/useExamGroupsGet";
import useExamGroupEditor from "../../hooks/exam-groups/useExamGroupEditor";
import ExamGroupEditor from "./support/examGroupEditor";
import { ExamCard } from "../../components/ExamCard";
import Theme from "../../theme";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

const ExamGroups = () => {
  const navigate = useNavigate();
  const {
    examGroups,
    loadingExamGroups,
    setCurrentGroup,
    refetch,
    isActive,
    setIsACtive,
    setSearchText,
    searchText,
    pageOptions,
    totalElements,
    limit,
    setLimit,
    setPage,
    page,
  } = useExamGroupsGet();

  const { deleteGroup } = useExamGroupEditor();

  const [modal, setModal] = useState({
    show: false,
    data: null,
  });
  const [deleteExamGroupsModal, setDeleteExamGroupsModal] = useState({
    openModal: false,
    data: null,
  });

  const groupData = examGroups?.items;
  const gotoExam = (id) => {
    navigate(`/exam-groups/${id}`);
  };

  const onEdit = (examGroup) => {
    setModal({ show: true, data: examGroup });
  };

  const onDelete = (data) => {
    let payload = {
      id: data?.id,
      callback: () => {
        refetch();
      },
    };
    deleteGroup(payload);
  };
  const closeModal = () => {
    setModal({
      show: false,
      data: null,
    });
  };
  return (
    <Box>
      <PageTitle>
        <i className="saf-3dcube" />
        <Text bold title="Papers" size={Theme.H3} style={{ padding: "0 10px" }}>
          Exam Groups
        </Text>
      </PageTitle>
      <Grid
        default="minmax(auto, 400px)  minmax(auto, 300px) auto max-content max-content"
        sm="1fr"
      >
        <Input
          name="search"
          placeholder="Search Exams"
          iconLeft="saf-search-normal"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Box>
          <Select
            placeholder="Status"
            options={[
              { label: "All", value: "" },
              { label: "Active", value: "ACTIVE" },
              { label: "Inactive", value: "INACTIVE" },
            ]}
            onChange={(e) => setIsACtive({ ...isActive, value: e.value })}
          />
        </Box>
        <Box />

        <>
          <Button onClick={() => setModal({ show: true, data: null })}>
            Create Exam Group
          </Button>
        </>
      </Grid>
      <Box margin="2rem 0">
        {loadingExamGroups ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section />
          </Box>
        ) : groupData?.length > 0 ? (
          <>
            <Grid default="repeat(4, minmax(100px, 1fr))" sm="1fr" gap="1rem">
              {groupData.map((examGroup) => (
                <ExamCard
                  handleRedirect={() => {
                    setCurrentGroup(examGroup);
                    gotoExam(examGroup?.id);
                  }}
                  handleEdit={() => onEdit(examGroup)}
                  handleDelete={() =>
                   setDeleteExamGroupsModal({
                        openModal: true,
                        data: examGroup,
                      })
                 
                  }
                  examData={examGroup}
                  examsCount={15}
                  subjectCount={5}
                />
              ))}
            </Grid>
            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <Box>
            <EmptyState
              type="documents"
              title="You have not created any exam group"
              info="Please create an exam group to proceed"
            />
          </Box>
        )}
      </Box>

      <ExamGroupEditor
        open={modal.show}
        data={modal.data}
        cbProps={{ refetchGroup: false, refetchGroups: true }}
        closeModal={closeModal}
      />
      <DeleteModal
        isOpen={deleteExamGroupsModal.openModal}
        onClose={() =>
          setDeleteExamGroupsModal({ openModal: false, data: null })
        }
        title="Delete Exam Group"
        description="The execution of this action will result in the removal of the exam group and all of its associated exams from the system."
        isLoading={loadingExamGroups}
        onDelete={() => {
          onDelete(deleteExamGroupsModal?.data);
          setDeleteExamGroupsModal({ openModal: false, data: null });
        }}
      />
    </Box>
  );
};

export default ExamGroups;
